// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2sOHa","col":"styles_col__1suBa","fulfillmentStatus":"styles_fulfillmentStatus__2-mAi","emailCol":"styles_emailCol__SGO-Q"};